// Provide a way to close an accordion sub menu externally.
export class AccordionCloser {
  constructor (elem) {
    this.elem = elem
    this.id = this.elem.dataset.subCloseId
    this.target = document.getElementById(this.id)

    this.elem.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      this.closeSubMenu()
    })

    this.elem.addEventListener('keydown', (e) => {
      if (e.keyCode === 13) {
        e.preventDefault()
        e.stopPropagation()
        this.closeSubMenu()
      }
    })
  }

  closeSubMenu () {
    if (this.target.hasAttribute('open')) {
      this.target.removeAttribute('open')
    }
  }
}

export function loadAccordionClosers () {
  const elems = document.querySelectorAll('[data-sub-close-id]')
  const accordionClosers = []

  for (const element of elems) {
    accordionClosers.push(new AccordionCloser(element))
  }

  return accordionClosers
}
